<template>
    <transition name="fade" mode="out-in" appear>
        <v-container fluid style="height: 100vh;" class="pa-0">
            <v-card class=" d-flex justify-center align-center" color="grey darken-3" style="height: 100%;" tile>
                <half-circle-spinner :animation-duration="2000" :size="150" color="#FFC000" />
            </v-card>
        </v-container>
    </transition>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'

export default {
     components: {
      HalfCircleSpinner
    }
}
</script>

<style scoped>

</style>